let courses = null
let courses_home = null
let course = null
let reviews = []
let lesson = null
let readMode = false
let certificatedCourses = null
let quiz = null
let quizHeader = null
let quizInfo = null
let submitQuiz = null
export default {
    courses,
    courses_home,
    course,
    reviews,
    certificatedCourses,
    quiz,
    quizHeader,
    quizInfo,
    submitQuiz,
    lesson,
    readMode
}